/*
 *
 * SignInPage actions
 *
 */

import {
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS,
  RESEND_VERIFICATION_FAILURE,
  RESET_FORM,

} from './constants';

export const signInRequest = (payload) => ({
  type: SIGN_IN_REQUEST,
  payload
});

export const signInSuccess = (payload) => ({
  type: SIGN_IN_SUCCESS,
  payload
});

export const signInFailure = (payload) => ({
  type: SIGN_IN_FAILURE,
  payload
});

export const resendVerificationEmailRequest = (payload) => ({
  type: RESEND_VERIFICATION_REQUEST,
  payload
});

export const resendVerificationEmailSuccess = () => ({
  type: RESEND_VERIFICATION_SUCCESS,
});

export const resendVerificationEmailFailure = () => ({
  type: RESEND_VERIFICATION_FAILURE,
});

export const resetForm = (payload) => ({
  type: RESET_FORM,
  payload
});

